import React from 'react';
import { motion } from 'framer-motion';
interface VisionSectionProps {
  data: {
    title: string;
    description: string;
  };
  isEditMode: boolean;
  onUpdate: (data: any) => void;
  searchQuery?: string;
}
export const VisionSection = ({
  data,
  isEditMode,
  onUpdate,
  searchQuery = ''
}: VisionSectionProps) => {
  const highlightText = (text: string) => {
    if (!searchQuery) return text;
    const parts = text.split(new RegExp(`(${searchQuery})`, 'gi'));
    return parts.map((part, i) => part.toLowerCase() === searchQuery.toLowerCase() ? <mark key={i} className="bg-yellow-200 dark:bg-yellow-600 px-1 rounded" data-id="element-215">
          {part}
        </mark> : part);
  };
  const hasMatch = !searchQuery || data.title.toLowerCase().includes(searchQuery.toLowerCase()) || data.description.toLowerCase().includes(searchQuery.toLowerCase());
  if (!hasMatch && searchQuery) return null;
  return <motion.section initial={{
    opacity: 0,
    y: 20
  }} animate={{
    opacity: 1,
    y: 0
  }} transition={{
    duration: 0.5
  }} className="rounded-2xl overflow-hidden shadow-xl hover:shadow-2xl transition-shadow duration-300" data-id="element-216">
      <div className="bg-gradient-to-r from-[#7FE5A8] to-[#5FD88F] py-5 sm:py-6 px-6 sm:px-8" data-id="element-217">
        <h2 className="text-xl sm:text-2xl font-bold text-[#1A2332] flex items-center" data-id="element-218">
          <span className="inline-block h-9 w-9 sm:h-11 sm:w-11 rounded-xl bg-[#1A2332] text-[#7FE5A8] flex items-center justify-center mr-3 sm:mr-4 text-base sm:text-lg font-bold shadow-md" data-id="element-219">
            1
          </span>
          Vision
        </h2>
      </div>
      <div className="bg-white dark:bg-[#1A2332] p-6 sm:p-10 space-y-4 sm:space-y-6" data-id="element-220">
        {isEditMode ? <>
            <textarea value={data.title} onChange={e => onUpdate({
          ...data,
          title: e.target.value
        })} className="w-full text-xl sm:text-2xl font-semibold text-[#1A2332] dark:text-white leading-relaxed border-2 border-[#7FE5A8] rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-[#7FE5A8] dark:bg-[#2A3F5F]" rows={2} data-id="element-221" />
            <textarea value={data.description} onChange={e => onUpdate({
          ...data,
          description: e.target.value
        })} className="w-full text-gray-600 dark:text-gray-300 text-base sm:text-lg leading-relaxed border-2 border-[#7FE5A8] rounded-xl p-4 focus:outline-none focus:ring-2 focus:ring-[#7FE5A8] dark:bg-[#2A3F5F]" rows={4} data-id="element-222" />
          </> : <>
            <p className="text-xl sm:text-2xl font-semibold text-[#1A2332] dark:text-white leading-relaxed" data-id="element-223">
              {highlightText(data.title)}
            </p>
            <p className="text-gray-600 dark:text-gray-300 text-base sm:text-lg leading-relaxed" data-id="element-224">
              {highlightText(data.description)}
            </p>
          </>}
      </div>
    </motion.section>;
};